import ApiService from "@/core/services/api.service";
import querystring from "querystring";
import SecureLS from "secure-ls";
import { responseError } from '@/core/mixin/shared'

const BASE = "USER";

const BASE_URL_SELF = "api/user/self";
const BASE_URL_CUSTOMERS = "api/user/customers";
const BASE_URL_TECHNICIANS = "api/user/technicians";
const ls = new SecureLS({ encodingType: "aes", isCompression: true });

export const MODULE_NAME = `userModule`;
export const BASE_URL = `api/users`;
export const LOADING = `${BASE}/LOADING`;
export const ERROR = `${BASE}/ERROR`;
export const SUCCESS = `${BASE}/SUCCESS`;
export const ITEMS = `${BASE}/ITEM`;
export const ITEM = `${BASE}/CURRENT_ITEM`;
export const SELF = `${BASE}/SELF`;
export const USER = `${BASE}/USER`;
export const GENERAL_SETTING = `${BASE}/GENERAL_SETTING`;
export const ITEMS_ALL = `${BASE}/ITEMS_ALL`;
export const CUSTOMERS = `${BASE}/CUSTOMERS`;
export const TECHNICIANS = `${BASE}/TECHNICIANS`;
export const PHOTO = `${BASE}/PHOTO`;

export const SET_LOADING = `${BASE}/M/LOADING`;
export const SET_ERROR = `${BASE}/M/ERROR`;
export const SET_SUCCESS = `${BASE}/M/SUCCESS`;
export const SET_ITEMS = `${BASE}/M/ITEMS`;
export const SET_ITEM = `${BASE}/M/CURRENT_ITEM`;
export const SET_SELF = `${BASE}/M/SELF`;
export const SET_USER = `${BASE}/M/SET_USER`;
export const SET_CUSTOMERS = `${BASE}/M/SET_CUSTOMERS`;
export const SET_TECHNICIANS = `${BASE}/M/SET_TECHNICIANS`;
export const RESET_VALUES = `${BASE}/M/RESET_VALUES`;
export const SET_ITEMS_ALL = `${BASE}/M/ITEMS_ALL`;
export const SET_PHOTO = `${BASE}/M/PHOTO`;

// ACTIONS
export const GET_ITEMS = `${BASE}/GET_ITEMS`;
export const GET_ITEM = `${BASE}/GET_ITEM`;
export const GET_USER = `${BASE}/GET_USER`;
export const GET_SELF = `${BASE}/GET_SELF`;
export const CREATE_ITEM = `${BASE}/CREATE_ITEM`;
export const UPDATE_ITEM = `${BASE}/UPDATE_ITEM`;
export const DELETE_ITEM = `${BASE}/DELETE_ITEM`;
export const GET_ALL_ITEMS = `${BASE}/GET_ALL_ITEMS`;
export const GET_CUSTOMERS = `${BASE}/GET_CUSTOMERS`;
export const GET_TECHNICIANS = `${BASE}/GET_TECHNICIANS`;
export const DELETE_PHOTO = `${BASE}/DELETE_PHOTO`;
export const UPLOAD_PHOTO = `${BASE}/UPLOAD_PHOTO`;
export const GET_PHOTO = `${BASE}/GET_PHOTO`;

const state = {
  items: null,
  items_all: null,
  item: {},
  self: null,
  user: null,
  loading: false,
  error: null,
  success: null,
  customers: null,
  technicians: null,
  photo: null
};

const getters = {
  [LOADING]: state => {
    return state.loading;
  },
  [ERROR]: state => {
    return state.error;
  },
  [SUCCESS]: state => {
    return state.success;
  },
  [ITEMS]: state => {
    return state.items;
  },
  [ITEM]: state => {
    return state.item;
  },
  [SELF]: state => {
    return state.self || JSON.parse(ls.get("user"));
  },
  [USER]: state => {
    return state.user;
  },
  [GENERAL_SETTING]: state => {
    return state.user.settings;
  },
  [ITEMS_ALL]: state => {
    return state.items_all;
  },
  [CUSTOMERS]: state => {
    return state.customers;
  },
  [TECHNICIANS]: state => {
    return state.technicians;
  },
  [PHOTO]: state => {
    return state.photo;
  }
};

const mutations = {
  [SET_LOADING]: (state, payload) => {
    state.loading = payload;
  },
  [SET_ERROR]: (state, payload) => {
    state.error = responseError(payload);
  },
  [SET_ITEMS]: (state, payload) => {
    state.items = payload;
  },
  [SET_SUCCESS]: (state, payload) => {
    state.success = payload;
  },
  [SET_ITEM]: (state, payload) => {
    state.item = payload;
  },
  [SET_USER]: (state, payload) => {
    state.user = payload;
    ls.set("user", JSON.stringify(payload));
  },
  [SET_SELF]: (state, payload) => {
    state.self = payload;
    ls.set("user", JSON.stringify(payload));
  },
  [SET_ITEMS_ALL]: (state, payload) => {
    state.items_all = payload;
  },
  [SET_CUSTOMERS]: (state, payload) => {
    state.customers = payload;
  },
  [SET_TECHNICIANS]: (state, payload) => {
    state.technicians = payload;
  },
  [SET_PHOTO]: (state, payload) => {
    state.photo = payload;
  },
  [RESET_VALUES]: state => {
    state.success = null;
    state.error = null;
    state.loading = false;
    state.item = {};
    state.items = [];
  }
};

const actions = {
  [GET_ALL_ITEMS]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_ITEMS_ALL, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_PHOTO]: (context, payload) => {
    let url = payload.url;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_PHOTO, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_CUSTOMERS]: (context, payload) => {
    let url = payload.url || BASE_URL_CUSTOMERS;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_CUSTOMERS, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_TECHNICIANS]: (context, payload) => {
    let url = payload.url || BASE_URL_TECHNICIANS;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_TECHNICIANS, response.data);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [GET_ITEMS]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let filters = payload.filters;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    if (filters) {
      url = `${url}?` + querystring.stringify(filters);
    }
    return ApiService.get(url)
      .then(response => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ITEMS, response.data);
      })
      .catch(error => {
        context.commit(SET_ERROR, error);
      });
  },
  [GET_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.get(url)
      .then(response => {
        context.commit(SET_ITEM, response.data);
        context.commit(SET_LOADING, false);
      })
      .catch(error => {
        context.commit(SET_ERROR, error);
      });
  },
  [GET_USER]: (context, payload) => {
    let url = payload.url || BASE_URL;
    context.commit(SET_LOADING, false);
    context.commit(SET_ERROR, null);
    return ApiService.get(url)
      .then(response => {
        context.commit(SET_USER, response.data);
        context.commit(SET_LOADING, false);
        return response.data;
      })
      .catch(error => {
        context.commit(SET_ERROR, error);
        return false;
      });
  },
  [GET_SELF]: (context) => {
    context.commit(SET_LOADING, false);
    context.commit(SET_ERROR, null);
    return ApiService.get(BASE_URL_SELF)
      .then(response => {
        context.commit(SET_SELF, response.data);
        context.commit(SET_LOADING, false);
        return response.data;
      })
      .catch(error => {
        context.commit(SET_ERROR, error);
        return false;
      });
  },
  [UPDATE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, false);
    ApiService.put(url, contents)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_ITEM, response.data);
          context.commit(SET_SUCCESS, true);
          context.commit(SET_ITEMS_ALL, null);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [UPLOAD_PHOTO]: (context, payload) => {
    let url = payload.url;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.post(url, contents)
        .then(response => {
          context.commit(SET_LOADING, false);
          return { status: true, data: response.data }
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [CREATE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL;
    let contents = payload.contents;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, false);
    ApiService.post(url, contents)
        .then(response => {
          context.commit(SET_LOADING, false);
          context.commit(SET_SUCCESS, true);
          context.commit(SET_ITEM, response.data);
          context.commit(SET_ITEMS_ALL, null);
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  },
  [DELETE_ITEM]: (context, payload) => {
    let url = payload.url || BASE_URL + "/" + payload.id;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    context.commit(SET_SUCCESS, null);
    ApiService.delete(url)
      .then(() => {
        context.commit(SET_LOADING, false);
        context.commit(SET_ITEM, {});
        context.commit(SET_ITEMS_ALL, null);
        context.commit(SET_SUCCESS, true);
      })
      .catch(error => {
        context.commit(SET_ERROR, error);
      });
  },
  [DELETE_PHOTO]: (context, payload) => {
    let url = payload.url;
    context.commit(SET_LOADING, true);
    context.commit(SET_ERROR, null);
    return ApiService.delete(url)
        .then((response) => {
          context.commit(SET_LOADING, false);

          return {status: true, data: response.data}
        })
        .catch(error => {
          context.commit(SET_ERROR, error);
        });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
